import { Address } from '../address';
import { Specialite } from '../specialite';

export class MissionPlace {
	readonly id: number;
	name: string;
	nameDisplay: string;
	specialties: Specialite[];
	address: Address;
	notes: string;
	version: number;

	constructor(
		options: {
			id?: number;
			name?: string;
			nameDisplay?: string;
			specialties?: Specialite[];
			address?: Address;
			notes?: string;
			version?: number;
		} = {}
	) {
		this.id = options.id || null;
		this.name = options.name || '';
		this.nameDisplay = options.nameDisplay || '';
		this.specialties = options.specialties || [];
		this.address = options.address || new Address();
		this.notes = options.notes || null;
		this.version = options.version || 0;
	}
}
